<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useUiStore } from '@/stores/ui.store'
import AppHeader from './components/AppHeader.vue'
import SidebarNav from './components/SidebarNav.vue'

const ui = useUiStore()
</script>

<template>
  <div class="bg-background min-h-screen">
    <!-- Sidebar desktop: Fixed tanpa animasi transisi lebar -->
    <aside
      class="bg-sidebar border-sidebar-border fixed inset-y-0 left-0 z-40 hidden border-r lg:flex lg:flex-col overflow-y-auto"
      :class="ui.sidebarCollapsed ? 'w-16' : 'w-64'"
    >
      <SidebarNav :collapsed="ui.sidebarCollapsed" />
    </aside>

    <!-- Konten Utama: Tanpa animasi transisi padding -->
    <div class="flex min-h-screen flex-col" :class="ui.sidebarCollapsed ? 'lg:pl-16' : 'lg:pl-64'">
      <AppHeader />
      <main class="flex-1 p-4 lg:p-6">
        <RouterView />
      </main>
    </div>
  </div>
</template>
